import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import NavbarVisitor from "../Component/NavbarVisitor";
import Footer from "../Component/Footer";
import Filterdata from "../Component/Filterdata";
import Sidefilter from "../Component/Sidefilter";
import { BASE_URL } from "../Component/Baseurl";
import $ from "jquery";
import "jquery-ui/ui/widgets/datepicker";
import "jquery-ui/themes/base/all.css";

const Filter = () => {
  const location = useLocation();

  const [filters, setFilters] = useState({
    country: "",
    state: "",
    city: "",
    industry: "",
    format: "",
    start_date: "",
    end_date: "",
  });

  const [industriesList, setIndustriesList] = useState([]);
  const [results, setResults] = useState([]);
  const [showAllCategories, setShowAllCategories] = useState(false);
  const [loading, setLoading] = useState(false);

  // Parse filters from SEO-friendly URL
  useEffect(() => {
    const pathParts = location.pathname.split("/").filter(Boolean);
    const filterMap = {};

    for (let i = 1; i < pathParts.length; i += 2) {
      const key = pathParts[i];
      const value = decodeURIComponent(pathParts[i + 1] || "").trim();
      if (key && value) filterMap[key] = value;
    }

    if (filterMap.dateRange) {
      const [start_date, end_date] = filterMap.dateRange.split("_");
      filterMap.start_date = start_date;
      filterMap.end_date = end_date;
      delete filterMap.dateRange;
    }

    setFilters((prev) => ({ ...prev, ...filterMap }));
  }, [location.pathname]);

  // Fetch industries
  useEffect(() => {
    const fetchIndustries = async () => {
      try {
        const res = await axios.get(`${BASE_URL}getAllIndustryByWorkshop`);
        if (res.data.success) setIndustriesList(res.data.industries);
      } catch (err) {
        console.error("Industry fetch error:", err);
      }
    };
    fetchIndustries();
  }, []);

  // jQuery Datepicker
  useEffect(() => {
    $("#start_date").datepicker({
      dateFormat: "yy-mm-dd",
      onSelect: (dateText) =>
        setFilters((prev) => ({ ...prev, start_date: dateText })),
    });

    $("#end_date").datepicker({
      dateFormat: "yy-mm-dd",
      onSelect: (dateText) =>
        setFilters((prev) => ({ ...prev, end_date: dateText })),
    });
  }, []);

  const handleCheckboxChange = (e, key) => {
    const { value, checked } = e.target;
    setFilters((prev) => ({
      ...prev,
      [key]: checked ? value : "",
    }));
  };

 const handleSearch = async (optionalFilters = null) => {
  const f = optionalFilters || filters;

  // Clean payload: only include truthy values
  const payload = {
    industries: f.industry ? [f.industry] : [],
    countries: f.country ? [f.country] : [],
    states: f.state ? [f.state] : [],
    cities: f.city ? [f.city] : [],
    formats: f.format ? [f.format] : [],
    start_date: f.start_date?.trim() || null,
    end_date: f.end_date?.trim() || null,
  };

  console.log("payload",payload);
  // Check if all fields are empty
  const isEmpty = Object.values(payload).every((val) =>
    Array.isArray(val) ? val.length === 0 : !val
  );
  if (isEmpty) {
    console.warn("Search skipped: all filters are empty.");
    return;
  }

  setLoading(true);
  try {
    const response = await axios.post(`${BASE_URL}getAllEvents`, payload);
    setResults(response.data?.events || []);
  } catch (err) {
    console.error("Error fetching filtered events:", err);
  } finally {
    setLoading(false);
  }
};


  useEffect(() => {
    handleSearch();
  }, [filters]);

  return (
    <>
      <NavbarVisitor />
      <div className="container">
        <div className="row mt-3">
          <div className="col">
            <h2 className="text-start mb-2">All Events</h2>
          </div>
        </div>
      </div>

      <div className="bg-light">
        <div className="container py-4">
          <div className="row">
            <div className="col-md-3 text-start p-2 bg-white">
              <Sidefilter
                filters={filters}
                setFilters={setFilters}
                industriesList={industriesList}
                handleCheckboxChange={handleCheckboxChange}
                handleSearch={handleSearch}
                showAllCategories={showAllCategories}
                setShowAllCategories={setShowAllCategories}
              />
            </div>

            <div className="col-md-6 col-12">
              {loading ? (
                <div className="text-center my-5">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : (
                <Filterdata results={results} />
              )}
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Filter;
